export default __webpack_public_path__ + "static/media/backicon.97fc77d6.svg";